import { Routes, Route } from "react-router-dom";
import React, { startTransition ,lazy, Suspense} from 'react';
import { useState } from 'react';
import { Toaster } from 'react-hot-toast';
import './index.css';

import Layout from './layout/Layout';
import MobileLayout from './layout/MobileLayout';
import ReelsPage from "./pages/ReelsPage";


// 1. Keep these STATIC (Needed immediately for wrappers, fallbacks, or maintenance)
import LoadingPage from './pages/LoadingPage';
import WorkingPage from './pages/WorkingPage';
import ProtectedRoute from "./components/ProtectedRoute";
import Explore from "./pages/Explore";

// 2. Change these to LAZY imports (These become separate JS chunks)
const AuthScreen = lazy(() => import('./components/AuthScreen'));
const LandingPage = lazy(() => import('./pages/LandingPage'));
const WelcomeFlow = lazy(() => import('./pages/WelcomeFlow'));
const ChatPage = lazy(() => import('./pages/ChatPage'));
const MasterSelection = lazy(() => import('./pages/MasterSelection'));
const AboutFounder = lazy(() => import('./pages/AboutFounder'));



import Observatory from './pages/Observatory';
import LiveObservatory from "./pages/ObservatoryLive";

// Insights Pages (Lazy Loaded)
const OverthinkingPage = lazy(() => import("./pages/Insights/OverthinkingPage"));
const AwarenessPage = lazy(() => import("./pages/Insights/AwarenessPage"));
const EmptinessPage = lazy(() => import("./pages/Insights/EmptinessPage"));
const DopamineDetoxPage = lazy(() => import("./pages/Insights/DopamineDetoxPage"));
const OshoAwarenessPage = lazy(() => import("./pages/Insights/OshoAwarenessPage"));
const KrishnamurtiThoughtPage = lazy(() => import("./pages/Insights/KrishnamurtiThoughtPage"));
const LiveInPresentPage = lazy(() => import("./pages/Insights/LiveInPresentPage"));
const WhatIsEgoPage = lazy(() => import("./pages/Insights/WhatIsEgoPage"));
const MeditationAwarenessPage = lazy(() => import("./pages/Insights/MeditationAwarenessPage"));
const AnxietyAwarenessPage = lazy(() => import("./pages/Insights/AnxietyAwarenessPage"));
const UnderstandingFearPage = lazy(() => import("./pages/Insights/UnderstandingFearPage"));
const AmbitionSuccessInnerPeacePage = lazy(() => import("./pages/Insights/AmbitionSuccessInnerPeacePage"));
const FearOfMissingOutPage = lazy(() => import("./pages/Insights/FearOfMissingOutPage"));
const WhySuccessDoesNotEndAnxietyPage = lazy(() => import("./pages/Insights/WhySuccessDoesNotEndAnxietyPage"));
const SocialMediaAndSelfWorthPage = lazy(() => import("./pages/Insights/SocialMediaAndSelfWorthPage"));
const BurnoutAndAwarenessPage = lazy(() => import("./pages/Insights/BurnoutAndAwarenessPage"));
const WhyYoungPeopleFeelLostPage = lazy(() => import("./pages/Insights/WhyYoungPeopleFeelLostPage"));
const ProductivityAndAnxietyPage = lazy(() => import("./pages/Insights/ProductivityAndAnxietyPage"));
const AIAndHumanConsciousnessPage  = lazy(() => import("./pages/Insights/AIAndHumanConsciousnessPage"));
const CanAIUnderstandEmotionsPage  = lazy(() => import("./pages/Insights/CanAIUnderstandEmotionsPage"));
const WhyPeopleTalkToAIPage  = lazy(() => import("./pages/Insights/WhyPeopleTalkToAIPage"));

export default function App() {
  const MAINTENANCE_MODE = false;
  const [transitioning, setTransitioning] = useState(false);
  const [selectedGuru, setSelectedGuru] = useState('osho');

  const handleScreenTransition = () => {
    setTransitioning(false);
    requestAnimationFrame(() => {
      setTransitioning(true);
    });
    setTimeout(() => {
      setTransitioning(false);
    }, 2600);
  };
  if (MAINTENANCE_MODE) {
    return (
      <Routes>
        <Route path="*" element={<WorkingPage />} />
      </Routes>
    );
  }

  return (
    <main id="main-content">
    <Toaster
      position="top-center"
      toastOptions={{
        style: {
          background: 'rgba(10,8,4,0.96)',
          color: '#d6c6a5',
          border: '1px solid rgba(201,168,76,0.2)',
          padding: '14px 18px',
          fontSize: '14px',
          fontStyle: 'italic',
          backdropFilter: 'blur(10px)',
          boxShadow: '0 0 30px rgba(201,168,76,0.08)',
          borderRadius: '14px',
        },

        duration: 4000,
      }}
    />
    <div className={`screen-transition ${transitioning ? 'active' : ''}`} />
    <Suspense fallback={<LoadingPage />}>
    <Routes>

      <Route path="/auth" element={<AuthScreen />} />
      <Route path="/" element={<Layout />}>
          <Route
        path="/"
        element={<LandingPage startTransition={handleScreenTransition} />}
      />
      
      </Route>
       <Route
            path="/explore"
            element={<Explore />}
          />
      
      <Route
        path="/welcome"
        element={<WelcomeFlow />}
      />
      <Route
        path="/loading"
        element={<LoadingPage />}
      />

<Route
  path="/chat"
  element={
    <ProtectedRoute>
      <MobileLayout />
    </ProtectedRoute>
  }
>
  <Route
    index
    element={
      <ChatPage
        selectedGuru={selectedGuru}
        setSelectedGuru={setSelectedGuru}
      />
    }
  />

  {/* <Route path="reels" element={<ReelsPage />} /> */}

  {/* <Route path="explore" element={<ExplorePage />} /> */}

  {/* <Route path="profile" element={<ProfilePage />} /> */}

</Route>

      <Route
        path="/multipresence"
        element={<MasterSelection setSelectedGuru={setSelectedGuru} selectedGuru={selectedGuru} />}
      />
      <Route
        path="/About"
        element={<AboutFounder />}
      />


      {/* SEO & AEO & GEO */}
      <Route
        path="/insights/how-to-stop-overthinking"
        element={<OverthinkingPage />}
      />

      <Route
        path="/insights/what-is-awareness"
        element={<AwarenessPage />}
      />

      <Route
        path="/insights/why-do-i-feel-empty"
        element={<EmptinessPage />}
      />

      <Route
        path="/insights/dopamine-detox"
        element={<DopamineDetoxPage />}
      />
      <Route
        path="/insights/osho-on-awareness"
        element={<OshoAwarenessPage />}
      />
      <Route
        path="/insights/krishnamurti-on-thought"
        element={<KrishnamurtiThoughtPage />}
      />
      <Route
        path="/insights/how-to-live-in-the-present"
        element={<LiveInPresentPage />}
      />
      <Route
        path="/insights/what-is-ego"
        element={<WhatIsEgoPage />}
      />
      <Route
        path="/insights/meditation-and-awareness"
        element={<MeditationAwarenessPage />}
      />
      <Route
        path="/insights/anxiety-and-awareness"
        element={<AnxietyAwarenessPage />}
      />
      <Route
  path="/insights/understanding-fear"
  element={<UnderstandingFearPage />}
/>
<Route
  path="/insights/ambition-success-and-inner-peace"
  element={<AmbitionSuccessInnerPeacePage />}
/>
<Route
  path="/insights/fear-of-missing-out"
  element={<FearOfMissingOutPage />}
/>
<Route
  path="/insights/why-success-does-not-end-anxiety"
  element={<WhySuccessDoesNotEndAnxietyPage />}
/>
<Route
  path="/insights/social-media-and-self-worth"
  element={<SocialMediaAndSelfWorthPage />}
/>
<Route
  path="/insights/burnout-and-awareness"
  element={<BurnoutAndAwarenessPage />}
/>
<Route
  path="/insights/why-young-people-feel-lost"
  element={<WhyYoungPeopleFeelLostPage />}
/>
<Route
  path="/insights/productivity-and-anxiety"
  element={<ProductivityAndAnxietyPage />}
/>
<Route
  path="/insights/ai-and-human-consciousness"
  element={<AIAndHumanConsciousnessPage  />}
/>
<Route
  path="/insights/can-ai-understand-emotions"
  element={<CanAIUnderstandEmotionsPage  />}
/>
<Route
  path="/insights/why-people-talk-to-ai"
  element={<WhyPeopleTalkToAIPage  />}
/>
    </Routes>
    </Suspense>



  </main>
  );
}